module.exports = __webpack_public_path__ + "media/src/images/icons/slim-star-8c91a6277bf3ae278927a499c34cf599.svg";